<tx-unauthenticated-pages-wrapper>
  <div class="logout-container align-items-center d-flex flex-column">
    <p>
      <strong>{{ autologinUrls.documentName }}</strong>
    </p>
    <p><strong>Your session has timed out.</strong></p>
    <ng-container
      *ngIf="
        autologinUrls.documentName && autologinUrls.recoverAutologinUrl && autologinUrls.recoverAutologinUrl !== '';
        else noRecover
      ">
      <p>
        You didn't save your last changes. You can click one of the buttons to recover your unsaved document or open the
        last saved version of the document.
      </p>
    </ng-container>
    <ng-template #noRecover>
      <p>Click the button to resume editing your document.</p>
    </ng-template>
    <div class="d-flex align-items-stretch column-gap-5">
      <a
        *ngIf="autologinUrls.documentName"
        class="btn btn-primary"
        [href]="autologinUrls.documentAutologinUrl"
        (click)="disableButton('document')"
        [class.disabled]="disabledButtons.document"
        target="_blank">
        Resume editing document
      </a>
      <a
        *ngIf="autologinUrls.recoverAutologinUrl && autologinUrls.recoverAutologinUrl !== ''"
        class="btn btn-primary ml-2"
        [href]="autologinUrls.recoverAutologinUrl"
        (click)="disableButton('recover')"
        [class.disabled]="disabledButtons.recover"
        target="_blank">
        Recover unsaved document
      </a>
    </div>
  </div>
</tx-unauthenticated-pages-wrapper>
